<template>
	<rr-text v-if="isSubmit"
	         :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
	         :text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_LIGHT" v-html="$t('form_send')"/>
	<form v-else @submit.prevent="validate">
		<rr-animate-input ref="inputs" v-for="(inputOpts, index) in inputs" :key="index" v-bind="inputOpts"/>
		<rr-animate-button ref="sb"
		           :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
		           :text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_LIGHT">
			{{ $t('input_send') }}&nbsp;<span v-html="require('!svg-inline-loader!@/assets/img/svg/link-arrow.svg')"/>
		</rr-animate-button>
	</form>
</template>

<script>
import ContactForm from './ContactForm'

export default {
	name: 'AnimateContactForm',
	extends: ContactForm,
}
</script>
